import { z } from 'zod';

import { MAX_LENGTH_MESSAGE, MIN_LENGTH_MESSAGE, REQUIRED_FIELD_MESSAGE } from '@/shared/constants/error-messages';

export const contactFormSchema = () =>
  z.object({
    telegram: z
      .string()
      .min(2, { message: MIN_LENGTH_MESSAGE })
      .max(250, { message: MAX_LENGTH_MESSAGE })
      .trim()
      .toLowerCase()
      .refine((value) => !!value, {
        message: REQUIRED_FIELD_MESSAGE,
        path: [],
      }),

    isAgreeWithPersonalDataProcessing: z.boolean().refine((value) => !!value, {
      message: REQUIRED_FIELD_MESSAGE,
      path: [],
    }),
  });

export type ContactFormSchema = z.infer<ReturnType<typeof contactFormSchema>>;
